import { render } from "./fifthSection.vue?vue&type=template&id=4aee5172"
const script = {}

import "./fifthSection.vue?vue&type=style&index=0&id=4aee5172&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__